import React, { Fragment, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { generatePayroll } from "../../../services/payroll";

const MONTHS = [
  { value: "1",  label: "January"   }, { value: "2",  label: "February"  },
  { value: "3",  label: "March"     }, { value: "4",  label: "April"     },
  { value: "5",  label: "May"       }, { value: "6",  label: "June"      },
  { value: "7",  label: "July"      }, { value: "8",  label: "August"    },
  { value: "9",  label: "September" }, { value: "10", label: "October"   },
  { value: "11", label: "November"  }, { value: "12", label: "December"  },
];

const currentYear  = new Date().getFullYear();
const YEARS = Array.from({ length: 5 }, (_, i) => ({ value: String(currentYear - 2 + i), label: String(currentYear - 2 + i) }));

export default function GeneratePayroll() {
  const navigate = useNavigate();
  const [month, setMonth]     = useState(MONTHS[new Date().getMonth()]);
  const [year, setYear]       = useState(YEARS.find((y) => y.value === String(currentYear)));
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  function handleGenerate() {
    setErrorMessage("");
    if (!month) { setErrorMessage("Please select month"); return; }
    if (!year)  { setErrorMessage("Please select year");  return; }

    setLoading(true);
    const temp = new FormData();
    temp.append("month", month.value);
    temp.append("year",  year.value);
    if (localStorage.getItem("Role") === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");

    generatePayroll(temp).then((res) => {
      setLoading(false);
      if (res?.status) {
        toast.success(res.message);
        navigate("/payroll/list");
      } else {
        setErrorMessage(res?.message || "Something went wrong");
      }
    });
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Generate Payroll</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Payroll</a></li>
            <li className="breadcrumb-item active" aria-current="page">Generate Payroll</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Month <span className="text-danger"> *</span></label>
                    <Select className="default-select" placeholder="Select Month" options={MONTHS} value={month} onChange={(e) => setMonth(e)} isClearable />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Year <span className="text-danger"> *</span></label>
                    <Select className="default-select" placeholder="Select Year" options={YEARS} value={year} onChange={(e) => setYear(e)} isClearable />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">&nbsp;</label>
                    <div>
                      <a onClick={handleGenerate} className={`btn btn-success me-2 ${loading ? "disabled" : ""}`}>
                        <i className="fa fa-play-circle me-1" /> {loading ? "Generating..." : "Generate"}
                      </a>
                      <a onClick={() => navigate("/payroll/list")} className="btn btn-secondary">View List</a>
                    </div>
                  </div>
                </Col>
              </Row>

              {errorMessage && <span className="text-danger">{errorMessage}</span>}

              <div className="mt-4 p-3" style={{ background: "#f8f9fa", borderRadius: "6px" }}>
                <h6 className="mb-2"><i className="fa fa-info-circle me-2 text-primary" />How payroll is calculated</h6>
                <ul className="mb-0" style={{ fontSize: "13px" }}>
                  <li>All active teachers and workers for the selected academy are included.</li>
                  <li>Salary is pro-rated based on present days (total days − approved leave days).</li>
                  <li>Each employee's salary structure (components + amounts) is applied automatically.</li>
                  <li>After generation, review the payroll in <strong>Payroll List</strong> before approving.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
